import { render, staticRenderFns } from "./AgentSettings.vue?vue&type=template&id=a6d50946"
import script from "./AgentSettings.vue?vue&type=script&lang=js"
export * from "./AgentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports